// Which rail row is highlighted, and which read as done or locked.
//
// `active` follows the step the merchant is looking at (the route), not their saved progress:
// the two differ constantly, and "Choose your features" has no backend step id, so a
// progress-only rule could never light it up. done/locked come from progress by position in
// this rail, which only holds the steps that apply, so a shorter rail stays consistent.
//
// `progressIndex` is the row of the first applicable step at or after the backend pointer:
// a pointer parked on a skipped step resolves forward, and a finished flow points past the end.
export const getRailState = ({ steps, index, currentKey, progressStepId, featuresDone }) => {
  const activeIndex = steps.findIndex((s) => s.key === currentKey)
  const active = index === activeIndex

  const firstUnfinished = steps.findIndex((s) =>
    s.stepId == null ? !featuresDone : s.stepId >= progressStepId
  )
  const progressIndex = firstUnfinished === -1 ? steps.length : firstUnfinished

  const topUpIndex = steps.findIndex((s) => s.step === "TOP_UP")
  const locked = topUpIndex !== -1 && progressIndex >= topUpIndex

  return {
    active,
    done: index < progressIndex && !active,
    block: locked ? index !== topUpIndex && !active : index > progressIndex && !active
  }
}
